/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const CONTENT_API_BASE_URL = new InjectionToken<string>('CONTENT_API_BASE_URL');

@Injectable()
export class PresentationAppService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param activityId (optional) 
     * @param studentId (optional) 
     * @return Success
     */
    getPresentationActivity(activityId: string | undefined, studentId: number | undefined): Observable<PresentationActivityDto> {
        let url_ = this.baseUrl + "/api/workbook/content/presentation/get-presentation-activity?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPresentationActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPresentationActivity(<any>response_);
                } catch (e) {
                    return <Observable<PresentationActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PresentationActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPresentationActivity(response: HttpResponseBase): Observable<PresentationActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PresentationActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PresentationActivityDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    trackProgress(body: TrackProgressRequest | undefined): Observable<TrackProgressResponse> {
        let url_ = this.baseUrl + "/api/workbook/content/presentation/track-progress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrackProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrackProgress(<any>response_);
                } catch (e) {
                    return <Observable<TrackProgressResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<TrackProgressResponse>><any>_observableThrow(response_);
        }));
    }

    protected processTrackProgress(response: HttpResponseBase): Observable<TrackProgressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrackProgressResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrackProgressResponse>(<any>null);
    }

    /**
     * @param attemptId (optional) 
     * @return Success
     */
    checkProgress(attemptId: string | undefined): Observable<PresentationProgressDto> {
        let url_ = this.baseUrl + "/api/workbook/content/presentation/check-progress?";
        if (attemptId === null)
            throw new Error("The parameter 'attemptId' cannot be null.");
        else if (attemptId !== undefined)
            url_ += "attemptId=" + encodeURIComponent("" + attemptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProgress(<any>response_);
                } catch (e) {
                    return <Observable<PresentationProgressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PresentationProgressDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckProgress(response: HttpResponseBase): Observable<PresentationProgressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PresentationProgressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PresentationProgressDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeAttempt(body: CompletePresentationRequest | undefined): Observable<CompletePresentationResponse> {
        let url_ = this.baseUrl + "/api/workbook/content/presentation/complete-attempt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteAttempt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteAttempt(<any>response_);
                } catch (e) {
                    return <Observable<CompletePresentationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompletePresentationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteAttempt(response: HttpResponseBase): Observable<CompletePresentationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompletePresentationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompletePresentationResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startPresentationActivity(body: StartPresentationRequest | undefined): Observable<StartPresentationResponse> {
        let url_ = this.baseUrl + "/api/workbook/content/presentation/start-presentation-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartPresentationActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartPresentationActivity(<any>response_);
                } catch (e) {
                    return <Observable<StartPresentationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<StartPresentationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processStartPresentationActivity(response: HttpResponseBase): Observable<StartPresentationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartPresentationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StartPresentationResponse>(<any>null);
    }
}

@Injectable()
export class QuizActivityAppService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startQuiz(body: StartQuizRequest | undefined): Observable<StartQuizResponse> {
        let url_ = this.baseUrl + "/api/workbook/content/quiz-activity/start-quiz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartQuiz(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartQuiz(<any>response_);
                } catch (e) {
                    return <Observable<StartQuizResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<StartQuizResponse>><any>_observableThrow(response_);
        }));
    }

    protected processStartQuiz(response: HttpResponseBase): Observable<StartQuizResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartQuizResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StartQuizResponse>(<any>null);
    }

    /**
     * @param attemptId (optional) 
     * @return Success
     */
    reviewQuizAttempt(attemptId: string | undefined): Observable<ReviewQuizAttemptOutput> {
        let url_ = this.baseUrl + "/api/workbook/content/quiz-activity/review-quiz-attempt?";
        if (attemptId === null)
            throw new Error("The parameter 'attemptId' cannot be null.");
        else if (attemptId !== undefined)
            url_ += "attemptId=" + encodeURIComponent("" + attemptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReviewQuizAttempt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReviewQuizAttempt(<any>response_);
                } catch (e) {
                    return <Observable<ReviewQuizAttemptOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReviewQuizAttemptOutput>><any>_observableThrow(response_);
        }));
    }

    protected processReviewQuizAttempt(response: HttpResponseBase): Observable<ReviewQuizAttemptOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReviewQuizAttemptOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReviewQuizAttemptOutput>(<any>null);
    }

    /**
     * @param quizId (optional) 
     * @return Success
     */
    getQuizActivity(quizId: string | undefined): Observable<GetQuizActivityResponse> {
        let url_ = this.baseUrl + "/api/workbook/content/quiz-activity/get-quiz-activity?";
        if (quizId === null)
            throw new Error("The parameter 'quizId' cannot be null.");
        else if (quizId !== undefined)
            url_ += "QuizId=" + encodeURIComponent("" + quizId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuizActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuizActivity(<any>response_);
                } catch (e) {
                    return <Observable<GetQuizActivityResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetQuizActivityResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuizActivity(response: HttpResponseBase): Observable<GetQuizActivityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQuizActivityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetQuizActivityResponse>(<any>null);
    }

    /**
     * @param activityId (optional) 
     * @param attemptId (optional) 
     * @param isReview (optional) 
     * @return Success
     */
    getQuizAttempt(activityId: string | undefined, attemptId: string | undefined, isReview: boolean | undefined): Observable<GetQuizAttemptResponse> {
        let url_ = this.baseUrl + "/api/workbook/content/quiz-activity/get-quiz-attempt?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "ActivityId=" + encodeURIComponent("" + activityId) + "&";
        if (attemptId === null)
            throw new Error("The parameter 'attemptId' cannot be null.");
        else if (attemptId !== undefined)
            url_ += "AttemptId=" + encodeURIComponent("" + attemptId) + "&";
        if (isReview === null)
            throw new Error("The parameter 'isReview' cannot be null.");
        else if (isReview !== undefined)
            url_ += "IsReview=" + encodeURIComponent("" + isReview) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuizAttempt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuizAttempt(<any>response_);
                } catch (e) {
                    return <Observable<GetQuizAttemptResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetQuizAttemptResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuizAttempt(response: HttpResponseBase): Observable<GetQuizAttemptResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQuizAttemptResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetQuizAttemptResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveResponses(body: SaveAnswersRequest | undefined): Observable<SaveAnswersResponse> {
        let url_ = this.baseUrl + "/api/workbook/content/quiz-activity/save-responses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveResponses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveResponses(<any>response_);
                } catch (e) {
                    return <Observable<SaveAnswersResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SaveAnswersResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSaveResponses(response: HttpResponseBase): Observable<SaveAnswersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveAnswersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveAnswersResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitQuiz(body: SubmitQuizRequest | undefined): Observable<SubmitQuizResponse> {
        let url_ = this.baseUrl + "/api/workbook/content/quiz-activity/submit-quiz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitQuiz(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitQuiz(<any>response_);
                } catch (e) {
                    return <Observable<SubmitQuizResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubmitQuizResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitQuiz(response: HttpResponseBase): Observable<SubmitQuizResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitQuizResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubmitQuizResponse>(<any>null);
    }
}

export enum ActivityStatusKind {
    Upcoming = <any>"Upcoming",
    Due = <any>"Due",
    InProgress = <any>"InProgress",
    Completed = <any>"Completed",
    Closed = <any>"Closed",
    Submitted = <any>"Submitted",
}

export class PresentationActivityDto implements IPresentationActivityDto {
    title: string | undefined;
    description: string | undefined;
    courseId: number;
    subjectId: number | undefined;
    subject: string | undefined;
    url: string | undefined;
    canTake: boolean;
    attemptId: string | undefined;
    activityId: string;
    status: ActivityStatusKind;
    reportsResults: boolean;
    assignmentType: string | undefined;

    constructor(data?: IPresentationActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.courseId = _data["courseId"];
            this.subjectId = _data["subjectId"];
            this.subject = _data["subject"];
            this.url = _data["url"];
            this.canTake = _data["canTake"];
            this.attemptId = _data["attemptId"];
            this.activityId = _data["activityId"];
            this.status = _data["status"];
            this.reportsResults = _data["reportsResults"];
            this.assignmentType = _data["assignmentType"];
        }
    }

    static fromJS(data: any): PresentationActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PresentationActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["courseId"] = this.courseId;
        data["subjectId"] = this.subjectId;
        data["subject"] = this.subject;
        data["url"] = this.url;
        data["canTake"] = this.canTake;
        data["attemptId"] = this.attemptId;
        data["activityId"] = this.activityId;
        data["status"] = this.status;
        data["reportsResults"] = this.reportsResults;
        data["assignmentType"] = this.assignmentType;
        return data; 
    }

    clone(): PresentationActivityDto {
        const json = this.toJSON();
        let result = new PresentationActivityDto();
        result.init(json);
        return result;
    }
}

export interface IPresentationActivityDto {
    title: string | undefined;
    description: string | undefined;
    courseId: number;
    subjectId: number | undefined;
    subject: string | undefined;
    url: string | undefined;
    canTake: boolean;
    attemptId: string | undefined;
    activityId: string;
    status: ActivityStatusKind;
    reportsResults: boolean;
    assignmentType: string | undefined;
}

export class TrackProgressRequest implements ITrackProgressRequest {
    activityId: string;
    attemptId: string;
    quizName: string | undefined;
    gradeScore: number;
    gradePercent: number;
    isComplete: boolean;

    constructor(data?: ITrackProgressRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.attemptId = _data["attemptId"];
            this.quizName = _data["quizName"];
            this.gradeScore = _data["gradeScore"];
            this.gradePercent = _data["gradePercent"];
            this.isComplete = _data["isComplete"];
        }
    }

    static fromJS(data: any): TrackProgressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TrackProgressRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["attemptId"] = this.attemptId;
        data["quizName"] = this.quizName;
        data["gradeScore"] = this.gradeScore;
        data["gradePercent"] = this.gradePercent;
        data["isComplete"] = this.isComplete;
        return data; 
    }

    clone(): TrackProgressRequest {
        const json = this.toJSON();
        let result = new TrackProgressRequest();
        result.init(json);
        return result;
    }
}

export interface ITrackProgressRequest {
    activityId: string;
    attemptId: string;
    quizName: string | undefined;
    gradeScore: number;
    gradePercent: number;
    isComplete: boolean;
}

export class ScoreResult implements IScoreResult {
    percentageScore: number;
    pointScore: number;
    totalPoints: number;

    constructor(data?: IScoreResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentageScore = _data["percentageScore"];
            this.pointScore = _data["pointScore"];
            this.totalPoints = _data["totalPoints"];
        }
    }

    static fromJS(data: any): ScoreResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentageScore"] = this.percentageScore;
        data["pointScore"] = this.pointScore;
        data["totalPoints"] = this.totalPoints;
        return data; 
    }

    clone(): ScoreResult {
        const json = this.toJSON();
        let result = new ScoreResult();
        result.init(json);
        return result;
    }
}

export interface IScoreResult {
    percentageScore: number;
    pointScore: number;
    totalPoints: number;
}

export class FeedbackResult implements IFeedbackResult {
    imageId: number;
    imageUrl: string | undefined;
    starRating: number;
    title: string | undefined;
    comments: string | undefined;

    constructor(data?: IFeedbackResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.imageUrl = _data["imageUrl"];
            this.starRating = _data["starRating"];
            this.title = _data["title"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): FeedbackResult {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["imageUrl"] = this.imageUrl;
        data["starRating"] = this.starRating;
        data["title"] = this.title;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): FeedbackResult {
        const json = this.toJSON();
        let result = new FeedbackResult();
        result.init(json);
        return result;
    }
}

export interface IFeedbackResult {
    imageId: number;
    imageUrl: string | undefined;
    starRating: number;
    title: string | undefined;
    comments: string | undefined;
}

export class TrackProgressResponse implements ITrackProgressResponse {
    attemptId: string;
    isCompleted: boolean;
    points: number;
    score: ScoreResult;
    feedback: FeedbackResult;

    constructor(data?: ITrackProgressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
            this.isCompleted = _data["isCompleted"];
            this.points = _data["points"];
            this.score = _data["score"] ? ScoreResult.fromJS(_data["score"]) : <any>undefined;
            this.feedback = _data["feedback"] ? FeedbackResult.fromJS(_data["feedback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrackProgressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrackProgressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        data["isCompleted"] = this.isCompleted;
        data["points"] = this.points;
        data["score"] = this.score ? this.score.toJSON() : <any>undefined;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        return data; 
    }

    clone(): TrackProgressResponse {
        const json = this.toJSON();
        let result = new TrackProgressResponse();
        result.init(json);
        return result;
    }
}

export interface ITrackProgressResponse {
    attemptId: string;
    isCompleted: boolean;
    points: number;
    score: ScoreResult;
    feedback: FeedbackResult;
}

export class PresentationProgressDto implements IPresentationProgressDto {
    totalQuizzes: number;
    completedQuizzes: number;
    isComplete: boolean;

    constructor(data?: IPresentationProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalQuizzes = _data["totalQuizzes"];
            this.completedQuizzes = _data["completedQuizzes"];
            this.isComplete = _data["isComplete"];
        }
    }

    static fromJS(data: any): PresentationProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PresentationProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalQuizzes"] = this.totalQuizzes;
        data["completedQuizzes"] = this.completedQuizzes;
        data["isComplete"] = this.isComplete;
        return data; 
    }

    clone(): PresentationProgressDto {
        const json = this.toJSON();
        let result = new PresentationProgressDto();
        result.init(json);
        return result;
    }
}

export interface IPresentationProgressDto {
    totalQuizzes: number;
    completedQuizzes: number;
    isComplete: boolean;
}

export class CompletePresentationRequest implements ICompletePresentationRequest {
    attemptId: string;
    activityId: string;

    constructor(data?: ICompletePresentationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
            this.activityId = _data["activityId"];
        }
    }

    static fromJS(data: any): CompletePresentationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePresentationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        data["activityId"] = this.activityId;
        return data; 
    }

    clone(): CompletePresentationRequest {
        const json = this.toJSON();
        let result = new CompletePresentationRequest();
        result.init(json);
        return result;
    }
}

export interface ICompletePresentationRequest {
    attemptId: string;
    activityId: string;
}

export class CompletePresentationResponse implements ICompletePresentationResponse {
    attemptId: string;
    points: number;
    score: ScoreResult;
    feedback: FeedbackResult;

    constructor(data?: ICompletePresentationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
            this.points = _data["points"];
            this.score = _data["score"] ? ScoreResult.fromJS(_data["score"]) : <any>undefined;
            this.feedback = _data["feedback"] ? FeedbackResult.fromJS(_data["feedback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompletePresentationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePresentationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        data["points"] = this.points;
        data["score"] = this.score ? this.score.toJSON() : <any>undefined;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CompletePresentationResponse {
        const json = this.toJSON();
        let result = new CompletePresentationResponse();
        result.init(json);
        return result;
    }
}

export interface ICompletePresentationResponse {
    attemptId: string;
    points: number;
    score: ScoreResult;
    feedback: FeedbackResult;
}

export class StartPresentationRequest implements IStartPresentationRequest {
    activityId: string;
    studentId: number;
    readonly id: string;

    constructor(data?: IStartPresentationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.studentId = _data["studentId"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): StartPresentationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartPresentationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["studentId"] = this.studentId;
        data["id"] = this.id;
        return data; 
    }

    clone(): StartPresentationRequest {
        const json = this.toJSON();
        let result = new StartPresentationRequest();
        result.init(json);
        return result;
    }
}

export interface IStartPresentationRequest {
    activityId: string;
    studentId: number;
    id: string;
}

export class StartPresentationResponse implements IStartPresentationResponse {
    attemptId: string;

    constructor(data?: IStartPresentationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
        }
    }

    static fromJS(data: any): StartPresentationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartPresentationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        return data; 
    }

    clone(): StartPresentationResponse {
        const json = this.toJSON();
        let result = new StartPresentationResponse();
        result.init(json);
        return result;
    }
}

export interface IStartPresentationResponse {
    attemptId: string;
}

export class StartQuizRequest implements IStartQuizRequest {
    quizId: string;

    constructor(data?: IStartQuizRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quizId = _data["quizId"];
        }
    }

    static fromJS(data: any): StartQuizRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartQuizRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quizId"] = this.quizId;
        return data; 
    }

    clone(): StartQuizRequest {
        const json = this.toJSON();
        let result = new StartQuizRequest();
        result.init(json);
        return result;
    }
}

export interface IStartQuizRequest {
    quizId: string;
}

export enum AttemptStatusKind {
    InProgress = <any>"InProgress",
    Submitted = <any>"Submitted",
    Marked = <any>"Marked",
    Completed = <any>"Completed",
}

export class QuizAttemptDto implements IQuizAttemptDto {
    gradePercentage: number;
    score: ScoreResult;
    feedback: FeedbackResult;
    submittedTime: moment.Moment | undefined;
    attemptStatus: AttemptStatusKind;
    isCompleted: boolean;
    correct: number | undefined;
    incorrect: number | undefined;
    notAttempted: number | undefined;
    partiallyCorrect: number | undefined;
    id: string;

    constructor(data?: IQuizAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gradePercentage = _data["gradePercentage"];
            this.score = _data["score"] ? ScoreResult.fromJS(_data["score"]) : <any>undefined;
            this.feedback = _data["feedback"] ? FeedbackResult.fromJS(_data["feedback"]) : <any>undefined;
            this.submittedTime = _data["submittedTime"] ? moment(_data["submittedTime"].toString()) : <any>undefined;
            this.attemptStatus = _data["attemptStatus"];
            this.isCompleted = _data["isCompleted"];
            this.correct = _data["correct"];
            this.incorrect = _data["incorrect"];
            this.notAttempted = _data["notAttempted"];
            this.partiallyCorrect = _data["partiallyCorrect"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QuizAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gradePercentage"] = this.gradePercentage;
        data["score"] = this.score ? this.score.toJSON() : <any>undefined;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["submittedTime"] = this.submittedTime ? this.submittedTime.toISOString() : <any>undefined;
        data["attemptStatus"] = this.attemptStatus;
        data["isCompleted"] = this.isCompleted;
        data["correct"] = this.correct;
        data["incorrect"] = this.incorrect;
        data["notAttempted"] = this.notAttempted;
        data["partiallyCorrect"] = this.partiallyCorrect;
        data["id"] = this.id;
        return data; 
    }

    clone(): QuizAttemptDto {
        const json = this.toJSON();
        let result = new QuizAttemptDto();
        result.init(json);
        return result;
    }
}

export interface IQuizAttemptDto {
    gradePercentage: number;
    score: ScoreResult;
    feedback: FeedbackResult;
    submittedTime: moment.Moment | undefined;
    attemptStatus: AttemptStatusKind;
    isCompleted: boolean;
    correct: number | undefined;
    incorrect: number | undefined;
    notAttempted: number | undefined;
    partiallyCorrect: number | undefined;
    id: string;
}

export class StartQuizResponse implements IStartQuizResponse {
    attemptId: string;
    attempt: QuizAttemptDto;

    constructor(data?: IStartQuizResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
            this.attempt = _data["attempt"] ? QuizAttemptDto.fromJS(_data["attempt"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StartQuizResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartQuizResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        data["attempt"] = this.attempt ? this.attempt.toJSON() : <any>undefined;
        return data; 
    }

    clone(): StartQuizResponse {
        const json = this.toJSON();
        let result = new StartQuizResponse();
        result.init(json);
        return result;
    }
}

export interface IStartQuizResponse {
    attemptId: string;
    attempt: QuizAttemptDto;
}

export class QuizActivityDto implements IQuizActivityDto {
    title: string | undefined;
    subject: string | undefined;
    isTimed: boolean;
    timeLimit: number;
    allowMultipleAttempts: boolean;
    maximumAttempts: number;
    attemptsMade: number;
    canTake: boolean;
    lastAttemptId: string;
    status: ActivityStatusKind;
    assignmentType: string | undefined;
    showProgress: boolean;

    constructor(data?: IQuizActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.subject = _data["subject"];
            this.isTimed = _data["isTimed"];
            this.timeLimit = _data["timeLimit"];
            this.allowMultipleAttempts = _data["allowMultipleAttempts"];
            this.maximumAttempts = _data["maximumAttempts"];
            this.attemptsMade = _data["attemptsMade"];
            this.canTake = _data["canTake"];
            this.lastAttemptId = _data["lastAttemptId"];
            this.status = _data["status"];
            this.assignmentType = _data["assignmentType"];
            this.showProgress = _data["showProgress"];
        }
    }

    static fromJS(data: any): QuizActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subject"] = this.subject;
        data["isTimed"] = this.isTimed;
        data["timeLimit"] = this.timeLimit;
        data["allowMultipleAttempts"] = this.allowMultipleAttempts;
        data["maximumAttempts"] = this.maximumAttempts;
        data["attemptsMade"] = this.attemptsMade;
        data["canTake"] = this.canTake;
        data["lastAttemptId"] = this.lastAttemptId;
        data["status"] = this.status;
        data["assignmentType"] = this.assignmentType;
        data["showProgress"] = this.showProgress;
        return data; 
    }

    clone(): QuizActivityDto {
        const json = this.toJSON();
        let result = new QuizActivityDto();
        result.init(json);
        return result;
    }
}

export interface IQuizActivityDto {
    title: string | undefined;
    subject: string | undefined;
    isTimed: boolean;
    timeLimit: number;
    allowMultipleAttempts: boolean;
    maximumAttempts: number;
    attemptsMade: number;
    canTake: boolean;
    lastAttemptId: string;
    status: ActivityStatusKind;
    assignmentType: string | undefined;
    showProgress: boolean;
}

export class ReviewQuizAttemptOutput implements IReviewQuizAttemptOutput {
    studentFullName: string | undefined;
    quiz: QuizActivityDto;

    constructor(data?: IReviewQuizAttemptOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentFullName = _data["studentFullName"];
            this.quiz = _data["quiz"] ? QuizActivityDto.fromJS(_data["quiz"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReviewQuizAttemptOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewQuizAttemptOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentFullName"] = this.studentFullName;
        data["quiz"] = this.quiz ? this.quiz.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ReviewQuizAttemptOutput {
        const json = this.toJSON();
        let result = new ReviewQuizAttemptOutput();
        result.init(json);
        return result;
    }
}

export interface IReviewQuizAttemptOutput {
    studentFullName: string | undefined;
    quiz: QuizActivityDto;
}

export class GetQuizActivityResponse implements IGetQuizActivityResponse {
    quiz: QuizActivityDto;
    attempts: QuizAttemptDto[] | undefined;

    constructor(data?: IGetQuizActivityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quiz = _data["quiz"] ? QuizActivityDto.fromJS(_data["quiz"]) : <any>undefined;
            if (Array.isArray(_data["attempts"])) {
                this.attempts = [] as any;
                for (let item of _data["attempts"])
                    this.attempts.push(QuizAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQuizActivityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuizActivityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quiz"] = this.quiz ? this.quiz.toJSON() : <any>undefined;
        if (Array.isArray(this.attempts)) {
            data["attempts"] = [];
            for (let item of this.attempts)
                data["attempts"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetQuizActivityResponse {
        const json = this.toJSON();
        let result = new GetQuizActivityResponse();
        result.init(json);
        return result;
    }
}

export interface IGetQuizActivityResponse {
    quiz: QuizActivityDto;
    attempts: QuizAttemptDto[] | undefined;
}

export class MediaFieldBaseOfImageField implements IMediaFieldBaseOfImageField {
    id: number;
    url: string | undefined;
    readonly hasValue: boolean;

    protected _discriminator: string;

    constructor(data?: IMediaFieldBaseOfImageField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "MediaFieldBaseOfImageField";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            (<any>this).hasValue = _data["hasValue"];
        }
    }

    static fromJS(data: any): MediaFieldBaseOfImageField {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ImageField") {
            let result = new ImageField();
            result.init(data);
            return result;
        }
        let result = new MediaFieldBaseOfImageField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["id"] = this.id;
        data["url"] = this.url;
        data["hasValue"] = this.hasValue;
        return data; 
    }

    clone(): MediaFieldBaseOfImageField {
        const json = this.toJSON();
        let result = new MediaFieldBaseOfImageField();
        result.init(json);
        return result;
    }
}

export interface IMediaFieldBaseOfImageField {
    id: number;
    url: string | undefined;
    hasValue: boolean;
}

export class ImageField extends MediaFieldBaseOfImageField implements IImageField {

    constructor(data?: IImageField) {
        super(data);
        this._discriminator = "ImageField";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ImageField {
        data = typeof data === 'object' ? data : {};
        let result = new ImageField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): ImageField {
        const json = this.toJSON();
        let result = new ImageField();
        result.init(json);
        return result;
    }
}

export interface IImageField extends IMediaFieldBaseOfImageField {
}

export enum ContentLayoutKind {
    TextOnly = <any>"TextOnly",
    ImageLeft = <any>"ImageLeft",
    ImageTop = <any>"ImageTop",
    ImageRight = <any>"ImageRight",
    ImageBottom = <any>"ImageBottom",
    ImageOnly = <any>"ImageOnly",
    None = <any>"None",
}

export enum TextFormatKind {
    Plain = <any>"Plain",
    Html = <any>"Html",
    Markdown = <any>"Markdown",
}

export class Block implements IBlock {
    colSpan: number;
    type: string | undefined;

    protected _discriminator: string;

    constructor(data?: IBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "Block";
    }

    init(_data?: any) {
        if (_data) {
            this.colSpan = _data["colSpan"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Block {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "SimpleContentBlock") {
            let result = new SimpleContentBlock();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ColumnBlock") {
            let result = new ColumnBlock();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BlockGroup") {
            let result = new BlockGroup();
            result.init(data);
            return result;
        }
        if (data["$type"] === "HtmlBlock") {
            let result = new HtmlBlock();
            result.init(data);
            return result;
        }
        if (data["$type"] === "HtmlColumnBlock") {
            let result = new HtmlColumnBlock();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextBlock") {
            let result = new TextBlock();
            result.init(data);
            return result;
        }
        let result = new Block();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["colSpan"] = this.colSpan;
        data["type"] = this.type;
        return data; 
    }

    clone(): Block {
        const json = this.toJSON();
        let result = new Block();
        result.init(json);
        return result;
    }
}

export interface IBlock {
    colSpan: number;
    type: string | undefined;
}

export class SimpleContentBlock extends Block implements ISimpleContentBlock {
    text: string | undefined;
    image: ImageField;
    title: string | undefined;
    layout: ContentLayoutKind;
    textFormat: TextFormatKind;

    constructor(data?: ISimpleContentBlock) {
        super(data);
        this._discriminator = "SimpleContentBlock";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.title = _data["title"];
            this.layout = _data["layout"];
            this.textFormat = _data["textFormat"];
        }
    }

    static fromJS(data: any): SimpleContentBlock {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleContentBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["layout"] = this.layout;
        data["textFormat"] = this.textFormat;
        super.toJSON(data);
        return data; 
    }

    clone(): SimpleContentBlock {
        const json = this.toJSON();
        let result = new SimpleContentBlock();
        result.init(json);
        return result;
    }
}

export interface ISimpleContentBlock extends IBlock {
    text: string | undefined;
    image: ImageField;
    title: string | undefined;
    layout: ContentLayoutKind;
    textFormat: TextFormatKind;
}

export class ChoiceDto implements IChoiceDto {
    name: string | undefined;
    readonly key: string | undefined;
    index: number;
    isCorrect: boolean;
    image: ImageField;
    text: string | undefined;

    constructor(data?: IChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            (<any>this).key = _data["key"];
            this.index = _data["index"];
            this.isCorrect = _data["isCorrect"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["key"] = this.key;
        data["index"] = this.index;
        data["isCorrect"] = this.isCorrect;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["text"] = this.text;
        return data; 
    }

    clone(): ChoiceDto {
        const json = this.toJSON();
        let result = new ChoiceDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceDto {
    name: string | undefined;
    key: string | undefined;
    index: number;
    isCorrect: boolean;
    image: ImageField;
    text: string | undefined;
}

export enum ChoiceKind {
    Single = <any>"Single",
    Multiple = <any>"Multiple",
    Any = <any>"Any",
}

export class ChoiceGroupDto implements IChoiceGroupDto {
    values: ChoiceDto[] | undefined;
    choiceType: ChoiceKind;
    columns: number;
    layout: ContentLayoutKind;
    textFormat: TextFormatKind;

    constructor(data?: IChoiceGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(ChoiceDto.fromJS(item));
            }
            this.choiceType = _data["choiceType"];
            this.columns = _data["columns"];
            this.layout = _data["layout"];
            this.textFormat = _data["textFormat"];
        }
    }

    static fromJS(data: any): ChoiceGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["choiceType"] = this.choiceType;
        data["columns"] = this.columns;
        data["layout"] = this.layout;
        data["textFormat"] = this.textFormat;
        return data; 
    }

    clone(): ChoiceGroupDto {
        const json = this.toJSON();
        let result = new ChoiceGroupDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceGroupDto {
    values: ChoiceDto[] | undefined;
    choiceType: ChoiceKind;
    columns: number;
    layout: ContentLayoutKind;
    textFormat: TextFormatKind;
}

export class Hint implements IHint {
    content: SimpleContentBlock;

    constructor(data?: IHint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Hint {
        data = typeof data === 'object' ? data : {};
        let result = new Hint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data; 
    }

    clone(): Hint {
        const json = this.toJSON();
        let result = new Hint();
        result.init(json);
        return result;
    }
}

export interface IHint {
    content: SimpleContentBlock;
}

export class ProblemDto implements IProblemDto {
    isReadOnly: boolean;
    solution: SimpleContentBlock;
    hints: Hint[] | undefined;
    type: string | undefined;

    protected _discriminator: string;

    constructor(data?: IProblemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ProblemDto";
    }

    init(_data?: any) {
        if (_data) {
            this.isReadOnly = _data["isReadOnly"];
            this.solution = _data["solution"] ? SimpleContentBlock.fromJS(_data["solution"]) : <any>undefined;
            if (Array.isArray(_data["hints"])) {
                this.hints = [] as any;
                for (let item of _data["hints"])
                    this.hints.push(Hint.fromJS(item));
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ProblemDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "MultiChoiceProblemDto") {
            let result = new MultiChoiceProblemDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MultiEntryProblemDto") {
            let result = new MultiEntryProblemDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextInputProblemDto") {
            let result = new TextInputProblemDto();
            result.init(data);
            return result;
        }
        let result = new ProblemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["isReadOnly"] = this.isReadOnly;
        data["solution"] = this.solution ? this.solution.toJSON() : <any>undefined;
        if (Array.isArray(this.hints)) {
            data["hints"] = [];
            for (let item of this.hints)
                data["hints"].push(item.toJSON());
        }
        data["type"] = this.type;
        return data; 
    }

    clone(): ProblemDto {
        const json = this.toJSON();
        let result = new ProblemDto();
        result.init(json);
        return result;
    }
}

export interface IProblemDto {
    isReadOnly: boolean;
    solution: SimpleContentBlock;
    hints: Hint[] | undefined;
    type: string | undefined;
}

export class MultiChoiceProblemDto extends ProblemDto implements IMultiChoiceProblemDto {
    content: SimpleContentBlock;
    choices: ChoiceGroupDto;

    constructor(data?: IMultiChoiceProblemDto) {
        super(data);
        this._discriminator = "MultiChoiceProblemDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            this.choices = _data["choices"] ? ChoiceGroupDto.fromJS(_data["choices"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MultiChoiceProblemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiChoiceProblemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["choices"] = this.choices ? this.choices.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): MultiChoiceProblemDto {
        const json = this.toJSON();
        let result = new MultiChoiceProblemDto();
        result.init(json);
        return result;
    }
}

export interface IMultiChoiceProblemDto extends IProblemDto {
    content: SimpleContentBlock;
    choices: ChoiceGroupDto;
}

export enum SegmentKind {
    Text = <any>"Text",
    Field = <any>"Field",
}

export class TextSegment implements ITextSegment {
    text: string | undefined;
    fieldKey: string | undefined;
    segmentType: SegmentKind;

    constructor(data?: ITextSegment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.fieldKey = _data["fieldKey"];
            this.segmentType = _data["segmentType"];
        }
    }

    static fromJS(data: any): TextSegment {
        data = typeof data === 'object' ? data : {};
        let result = new TextSegment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["fieldKey"] = this.fieldKey;
        data["segmentType"] = this.segmentType;
        return data; 
    }

    clone(): TextSegment {
        const json = this.toJSON();
        let result = new TextSegment();
        result.init(json);
        return result;
    }
}

export interface ITextSegment {
    text: string | undefined;
    fieldKey: string | undefined;
    segmentType: SegmentKind;
}

export enum MultiEntryType {
    FillBlank = <any>"FillBlank",
    SimpleInput = <any>"SimpleInput",
    EntryGridItem = <any>"EntryGridItem",
}

export enum EntryFieldKind {
    TextInput = <any>"TextInput",
    TextArea = <any>"TextArea",
    NumericInput = <any>"NumericInput",
    Dropdown = <any>"Dropdown",
    MultipleChoice = <any>"MultipleChoice",
    NoEntry = <any>"NoEntry",
}

export class EntryAnswer implements IEntryAnswer {
    value: string | undefined;

    constructor(data?: IEntryAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EntryAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new EntryAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data; 
    }

    clone(): EntryAnswer {
        const json = this.toJSON();
        let result = new EntryAnswer();
        result.init(json);
        return result;
    }
}

export interface IEntryAnswer {
    value: string | undefined;
}

export class EntryFieldDto implements IEntryFieldDto {
    textSegments: TextSegment[] | undefined;
    key: string | undefined;
    value: string | undefined;
    displayWidth: number;
    entryType: EntryFieldKind;
    layoutTemplate: string | undefined;
    text: string | undefined;
    image: ImageField;
    textFormat: TextFormatKind;
    choices: ChoiceGroupDto;
    answer: string | undefined;
    answers: EntryAnswer[] | undefined;
    index: number;
    hasSegments: boolean;

    constructor(data?: IEntryFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["textSegments"])) {
                this.textSegments = [] as any;
                for (let item of _data["textSegments"])
                    this.textSegments.push(TextSegment.fromJS(item));
            }
            this.key = _data["key"];
            this.value = _data["value"];
            this.displayWidth = _data["displayWidth"];
            this.entryType = _data["entryType"];
            this.layoutTemplate = _data["layoutTemplate"];
            this.text = _data["text"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.textFormat = _data["textFormat"];
            this.choices = _data["choices"] ? ChoiceGroupDto.fromJS(_data["choices"]) : <any>undefined;
            this.answer = _data["answer"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers.push(EntryAnswer.fromJS(item));
            }
            this.index = _data["index"];
            this.hasSegments = _data["hasSegments"];
        }
    }

    static fromJS(data: any): EntryFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntryFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.textSegments)) {
            data["textSegments"] = [];
            for (let item of this.textSegments)
                data["textSegments"].push(item.toJSON());
        }
        data["key"] = this.key;
        data["value"] = this.value;
        data["displayWidth"] = this.displayWidth;
        data["entryType"] = this.entryType;
        data["layoutTemplate"] = this.layoutTemplate;
        data["text"] = this.text;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["textFormat"] = this.textFormat;
        data["choices"] = this.choices ? this.choices.toJSON() : <any>undefined;
        data["answer"] = this.answer;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["index"] = this.index;
        data["hasSegments"] = this.hasSegments;
        return data; 
    }

    clone(): EntryFieldDto {
        const json = this.toJSON();
        let result = new EntryFieldDto();
        result.init(json);
        return result;
    }
}

export interface IEntryFieldDto {
    textSegments: TextSegment[] | undefined;
    key: string | undefined;
    value: string | undefined;
    displayWidth: number;
    entryType: EntryFieldKind;
    layoutTemplate: string | undefined;
    text: string | undefined;
    image: ImageField;
    textFormat: TextFormatKind;
    choices: ChoiceGroupDto;
    answer: string | undefined;
    answers: EntryAnswer[] | undefined;
    index: number;
    hasSegments: boolean;
}

export class MultiEntryProblemDto extends ProblemDto implements IMultiEntryProblemDto {
    textSegments: TextSegment[] | undefined;
    entryType: MultiEntryType;
    content: SimpleContentBlock;
    fields: EntryFieldDto[] | undefined;
    hasSegments: boolean;

    constructor(data?: IMultiEntryProblemDto) {
        super(data);
        this._discriminator = "MultiEntryProblemDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["textSegments"])) {
                this.textSegments = [] as any;
                for (let item of _data["textSegments"])
                    this.textSegments.push(TextSegment.fromJS(item));
            }
            this.entryType = _data["entryType"];
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields.push(EntryFieldDto.fromJS(item));
            }
            this.hasSegments = _data["hasSegments"];
        }
    }

    static fromJS(data: any): MultiEntryProblemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiEntryProblemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.textSegments)) {
            data["textSegments"] = [];
            for (let item of this.textSegments)
                data["textSegments"].push(item.toJSON());
        }
        data["entryType"] = this.entryType;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["hasSegments"] = this.hasSegments;
        super.toJSON(data);
        return data; 
    }

    clone(): MultiEntryProblemDto {
        const json = this.toJSON();
        let result = new MultiEntryProblemDto();
        result.init(json);
        return result;
    }
}

export interface IMultiEntryProblemDto extends IProblemDto {
    textSegments: TextSegment[] | undefined;
    entryType: MultiEntryType;
    content: SimpleContentBlock;
    fields: EntryFieldDto[] | undefined;
    hasSegments: boolean;
}

export class GridColumn implements IGridColumn {
    label: string | undefined;
    image: ImageField;
    choiceName: string | undefined;
    index: number;

    constructor(data?: IGridColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.choiceName = _data["choiceName"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): GridColumn {
        data = typeof data === 'object' ? data : {};
        let result = new GridColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["choiceName"] = this.choiceName;
        data["index"] = this.index;
        return data; 
    }

    clone(): GridColumn {
        const json = this.toJSON();
        let result = new GridColumn();
        result.init(json);
        return result;
    }
}

export interface IGridColumn {
    label: string | undefined;
    image: ImageField;
    choiceName: string | undefined;
    index: number;
}

export class MultiChoiceGrid implements IMultiChoiceGrid {
    content: SimpleContentBlock;
    labelColumn: GridColumn;
    answerColumns: GridColumn[] | undefined;
    colSpan: number;
    type: string | undefined;

    constructor(data?: IMultiChoiceGrid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            this.labelColumn = _data["labelColumn"] ? GridColumn.fromJS(_data["labelColumn"]) : <any>undefined;
            if (Array.isArray(_data["answerColumns"])) {
                this.answerColumns = [] as any;
                for (let item of _data["answerColumns"])
                    this.answerColumns.push(GridColumn.fromJS(item));
            }
            this.colSpan = _data["colSpan"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): MultiChoiceGrid {
        data = typeof data === 'object' ? data : {};
        let result = new MultiChoiceGrid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["labelColumn"] = this.labelColumn ? this.labelColumn.toJSON() : <any>undefined;
        if (Array.isArray(this.answerColumns)) {
            data["answerColumns"] = [];
            for (let item of this.answerColumns)
                data["answerColumns"].push(item.toJSON());
        }
        data["colSpan"] = this.colSpan;
        data["type"] = this.type;
        return data; 
    }

    clone(): MultiChoiceGrid {
        const json = this.toJSON();
        let result = new MultiChoiceGrid();
        result.init(json);
        return result;
    }
}

export interface IMultiChoiceGrid {
    content: SimpleContentBlock;
    labelColumn: GridColumn;
    answerColumns: GridColumn[] | undefined;
    colSpan: number;
    type: string | undefined;
}

export class TextInputProblemDto extends ProblemDto implements ITextInputProblemDto {
    content: SimpleContentBlock;
    lines: number;

    constructor(data?: ITextInputProblemDto) {
        super(data);
        this._discriminator = "TextInputProblemDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            this.lines = _data["lines"];
        }
    }

    static fromJS(data: any): TextInputProblemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextInputProblemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["lines"] = this.lines;
        super.toJSON(data);
        return data; 
    }

    clone(): TextInputProblemDto {
        const json = this.toJSON();
        let result = new TextInputProblemDto();
        result.init(json);
        return result;
    }
}

export interface ITextInputProblemDto extends IProblemDto {
    content: SimpleContentBlock;
    lines: number;
}

export class ScoreRule implements IScoreRule {
    isScored: boolean;
    points: number;
    weight: number;

    constructor(data?: IScoreRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isScored = _data["isScored"];
            this.points = _data["points"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): ScoreRule {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isScored"] = this.isScored;
        data["points"] = this.points;
        data["weight"] = this.weight;
        return data; 
    }

    clone(): ScoreRule {
        const json = this.toJSON();
        let result = new ScoreRule();
        result.init(json);
        return result;
    }
}

export interface IScoreRule {
    isScored: boolean;
    points: number;
    weight: number;
}

export class SimpleFieldOfString implements ISimpleFieldOfString {
    value: string | undefined;

    protected _discriminator: string;

    constructor(data?: ISimpleFieldOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "SimpleFieldOfString";
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SimpleFieldOfString {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "HtmlField") {
            let result = new HtmlField();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextField") {
            let result = new TextField();
            result.init(data);
            return result;
        }
        let result = new SimpleFieldOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["value"] = this.value;
        return data; 
    }

    clone(): SimpleFieldOfString {
        const json = this.toJSON();
        let result = new SimpleFieldOfString();
        result.init(json);
        return result;
    }
}

export interface ISimpleFieldOfString {
    value: string | undefined;
}

export class HtmlField extends SimpleFieldOfString implements IHtmlField {

    constructor(data?: IHtmlField) {
        super(data);
        this._discriminator = "HtmlField";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HtmlField {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): HtmlField {
        const json = this.toJSON();
        let result = new HtmlField();
        result.init(json);
        return result;
    }
}

export interface IHtmlField extends ISimpleFieldOfString {
}

export class HtmlBlock extends Block implements IHtmlBlock {
    body: HtmlField;

    constructor(data?: IHtmlBlock) {
        super(data);
        this._discriminator = "HtmlBlock";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.body = _data["body"] ? HtmlField.fromJS(_data["body"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HtmlBlock {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body ? this.body.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): HtmlBlock {
        const json = this.toJSON();
        let result = new HtmlBlock();
        result.init(json);
        return result;
    }
}

export interface IHtmlBlock extends IBlock {
    body: HtmlField;
}

export class HtmlColumnBlock extends Block implements IHtmlColumnBlock {
    column1: HtmlField;
    column2: HtmlField;

    constructor(data?: IHtmlColumnBlock) {
        super(data);
        this._discriminator = "HtmlColumnBlock";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.column1 = _data["column1"] ? HtmlField.fromJS(_data["column1"]) : <any>undefined;
            this.column2 = _data["column2"] ? HtmlField.fromJS(_data["column2"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HtmlColumnBlock {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlColumnBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column1"] = this.column1 ? this.column1.toJSON() : <any>undefined;
        data["column2"] = this.column2 ? this.column2.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): HtmlColumnBlock {
        const json = this.toJSON();
        let result = new HtmlColumnBlock();
        result.init(json);
        return result;
    }
}

export interface IHtmlColumnBlock extends IBlock {
    column1: HtmlField;
    column2: HtmlField;
}

export class TextField extends SimpleFieldOfString implements ITextField {
    format: TextFormatKind;

    constructor(data?: ITextField) {
        super(data);
        this._discriminator = "TextField";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): TextField {
        data = typeof data === 'object' ? data : {};
        let result = new TextField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["format"] = this.format;
        super.toJSON(data);
        return data; 
    }

    clone(): TextField {
        const json = this.toJSON();
        let result = new TextField();
        result.init(json);
        return result;
    }
}

export interface ITextField extends ISimpleFieldOfString {
    format: TextFormatKind;
}

export class TextBlock extends Block implements ITextBlock {
    body: TextField;

    constructor(data?: ITextBlock) {
        super(data);
        this._discriminator = "TextBlock";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.body = _data["body"] ? TextField.fromJS(_data["body"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TextBlock {
        data = typeof data === 'object' ? data : {};
        let result = new TextBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body ? this.body.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): TextBlock {
        const json = this.toJSON();
        let result = new TextBlock();
        result.init(json);
        return result;
    }
}

export interface ITextBlock extends IBlock {
    body: TextField;
}

export class BlockGroup extends Block implements IBlockGroup {
    items: ColumnBlock[] | undefined;

    protected _discriminator: string;

    constructor(data?: IBlockGroup) {
        super(data);
        this._discriminator = "BlockGroup";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ColumnBlock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BlockGroup {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ColumnBlock") {
            let result = new ColumnBlock();
            result.init(data);
            return result;
        }
        let result = new BlockGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): BlockGroup {
        const json = this.toJSON();
        let result = new BlockGroup();
        result.init(json);
        return result;
    }
}

export interface IBlockGroup extends IBlock {
    items: ColumnBlock[] | undefined;
}

export class ColumnBlock extends BlockGroup implements IColumnBlock {
    items: ColumnBlock[] | undefined;
    colSpan: number;
    type: string | undefined;

    constructor(data?: IColumnBlock) {
        super(data);
        this._discriminator = "ColumnBlock";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ColumnBlock.fromJS(item));
            }
            this.colSpan = _data["colSpan"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ColumnBlock {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["colSpan"] = this.colSpan;
        data["type"] = this.type;
        super.toJSON(data);
        return data; 
    }

    clone(): ColumnBlock {
        const json = this.toJSON();
        let result = new ColumnBlock();
        result.init(json);
        return result;
    }
}

export interface IColumnBlock extends IBlockGroup {
    items: ColumnBlock[] | undefined;
    colSpan: number;
    type: string | undefined;
}

export class QuizActivityItemDto implements IQuizActivityItemDto {
    multiChoiceProblem: MultiChoiceProblemDto;
    multiEntryProblem: MultiEntryProblemDto;
    multiChoiceGrid: MultiChoiceGrid;
    textInputProblem: TextInputProblemDto;
    id: string;
    quizId: string;
    pageId: string;
    parentId: string | undefined;
    pageIndex: number;
    itemNumber: number;
    itemIndex: number;
    layoutTemplate: string | undefined;
    isProblem: boolean;
    title: string | undefined;
    colSpan: number;
    scoring: ScoreRule;
    isActive: boolean;
    itemType: string | undefined;
    isGroup: boolean;
    simpleContentBlock: SimpleContentBlock;
    columnBlock: ColumnBlock;
    htmlColumnBlock: HtmlColumnBlock;
    htmlBlock: HtmlBlock;
    textBlock: TextBlock;

    constructor(data?: IQuizActivityItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiChoiceProblem = _data["multiChoiceProblem"] ? MultiChoiceProblemDto.fromJS(_data["multiChoiceProblem"]) : <any>undefined;
            this.multiEntryProblem = _data["multiEntryProblem"] ? MultiEntryProblemDto.fromJS(_data["multiEntryProblem"]) : <any>undefined;
            this.multiChoiceGrid = _data["multiChoiceGrid"] ? MultiChoiceGrid.fromJS(_data["multiChoiceGrid"]) : <any>undefined;
            this.textInputProblem = _data["textInputProblem"] ? TextInputProblemDto.fromJS(_data["textInputProblem"]) : <any>undefined;
            this.id = _data["id"];
            this.quizId = _data["quizId"];
            this.pageId = _data["pageId"];
            this.parentId = _data["parentId"];
            this.pageIndex = _data["pageIndex"];
            this.itemNumber = _data["itemNumber"];
            this.itemIndex = _data["itemIndex"];
            this.layoutTemplate = _data["layoutTemplate"];
            this.isProblem = _data["isProblem"];
            this.title = _data["title"];
            this.colSpan = _data["colSpan"];
            this.scoring = _data["scoring"] ? ScoreRule.fromJS(_data["scoring"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.itemType = _data["itemType"];
            this.isGroup = _data["isGroup"];
            this.simpleContentBlock = _data["simpleContentBlock"] ? SimpleContentBlock.fromJS(_data["simpleContentBlock"]) : <any>undefined;
            this.columnBlock = _data["columnBlock"] ? ColumnBlock.fromJS(_data["columnBlock"]) : <any>undefined;
            this.htmlColumnBlock = _data["htmlColumnBlock"] ? HtmlColumnBlock.fromJS(_data["htmlColumnBlock"]) : <any>undefined;
            this.htmlBlock = _data["htmlBlock"] ? HtmlBlock.fromJS(_data["htmlBlock"]) : <any>undefined;
            this.textBlock = _data["textBlock"] ? TextBlock.fromJS(_data["textBlock"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuizActivityItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizActivityItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiChoiceProblem"] = this.multiChoiceProblem ? this.multiChoiceProblem.toJSON() : <any>undefined;
        data["multiEntryProblem"] = this.multiEntryProblem ? this.multiEntryProblem.toJSON() : <any>undefined;
        data["multiChoiceGrid"] = this.multiChoiceGrid ? this.multiChoiceGrid.toJSON() : <any>undefined;
        data["textInputProblem"] = this.textInputProblem ? this.textInputProblem.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["quizId"] = this.quizId;
        data["pageId"] = this.pageId;
        data["parentId"] = this.parentId;
        data["pageIndex"] = this.pageIndex;
        data["itemNumber"] = this.itemNumber;
        data["itemIndex"] = this.itemIndex;
        data["layoutTemplate"] = this.layoutTemplate;
        data["isProblem"] = this.isProblem;
        data["title"] = this.title;
        data["colSpan"] = this.colSpan;
        data["scoring"] = this.scoring ? this.scoring.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["itemType"] = this.itemType;
        data["isGroup"] = this.isGroup;
        data["simpleContentBlock"] = this.simpleContentBlock ? this.simpleContentBlock.toJSON() : <any>undefined;
        data["columnBlock"] = this.columnBlock ? this.columnBlock.toJSON() : <any>undefined;
        data["htmlColumnBlock"] = this.htmlColumnBlock ? this.htmlColumnBlock.toJSON() : <any>undefined;
        data["htmlBlock"] = this.htmlBlock ? this.htmlBlock.toJSON() : <any>undefined;
        data["textBlock"] = this.textBlock ? this.textBlock.toJSON() : <any>undefined;
        return data; 
    }

    clone(): QuizActivityItemDto {
        const json = this.toJSON();
        let result = new QuizActivityItemDto();
        result.init(json);
        return result;
    }
}

export interface IQuizActivityItemDto {
    multiChoiceProblem: MultiChoiceProblemDto;
    multiEntryProblem: MultiEntryProblemDto;
    multiChoiceGrid: MultiChoiceGrid;
    textInputProblem: TextInputProblemDto;
    id: string;
    quizId: string;
    pageId: string;
    parentId: string | undefined;
    pageIndex: number;
    itemNumber: number;
    itemIndex: number;
    layoutTemplate: string | undefined;
    isProblem: boolean;
    title: string | undefined;
    colSpan: number;
    scoring: ScoreRule;
    isActive: boolean;
    itemType: string | undefined;
    isGroup: boolean;
    simpleContentBlock: SimpleContentBlock;
    columnBlock: ColumnBlock;
    htmlColumnBlock: HtmlColumnBlock;
    htmlBlock: HtmlBlock;
    textBlock: TextBlock;
}

export class QuizPageDto implements IQuizPageDto {
    quizId: string;
    title: string | undefined;
    itemIndex: number;
    id: string;

    constructor(data?: IQuizPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quizId = _data["quizId"];
            this.title = _data["title"];
            this.itemIndex = _data["itemIndex"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QuizPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quizId"] = this.quizId;
        data["title"] = this.title;
        data["itemIndex"] = this.itemIndex;
        data["id"] = this.id;
        return data; 
    }

    clone(): QuizPageDto {
        const json = this.toJSON();
        let result = new QuizPageDto();
        result.init(json);
        return result;
    }
}

export interface IQuizPageDto {
    quizId: string;
    title: string | undefined;
    itemIndex: number;
    id: string;
}

export enum MarkResultKind {
    NotMarked = <any>"NotMarked",
    InCorrect = <any>"InCorrect",
    PartiallyCorrect = <any>"PartiallyCorrect",
    Correct = <any>"Correct",
    NoResponse = <any>"NoResponse",
    MarkerNotFound = <any>"MarkerNotFound",
}

export class Mark implements IMark {
    result: MarkResultKind;
    raw: number;
    weighted: number;

    constructor(data?: IMark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.raw = _data["raw"];
            this.weighted = _data["weighted"];
        }
    }

    static fromJS(data: any): Mark {
        data = typeof data === 'object' ? data : {};
        let result = new Mark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["raw"] = this.raw;
        data["weighted"] = this.weighted;
        return data; 
    }

    clone(): Mark {
        const json = this.toJSON();
        let result = new Mark();
        result.init(json);
        return result;
    }
}

export interface IMark {
    result: MarkResultKind;
    raw: number;
    weighted: number;
}

export enum MarkerModeKind {
    Automatic = <any>"Automatic",
    Manual = <any>"Manual",
}

export enum MarkStatusKind {
    New = <any>"New",
    Submitted = <any>"Submitted",
    Completed = <any>"Completed",
    Error = <any>"Error",
}

export class ResponseEntry implements IResponseEntry {
    key: string | undefined;
    values: { [key: string]: string; } | undefined;
    readonly hasValue: boolean;
    readonly isCorrect: boolean | undefined;
    mark: MarkResultKind;
    earnedPoints: number;

    constructor(data?: IResponseEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)[key] = _data["values"][key];
                }
            }
            (<any>this).hasValue = _data["hasValue"];
            (<any>this).isCorrect = _data["isCorrect"];
            this.mark = _data["mark"];
            this.earnedPoints = _data["earnedPoints"];
        }
    }

    static fromJS(data: any): ResponseEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key];
            }
        }
        data["hasValue"] = this.hasValue;
        data["isCorrect"] = this.isCorrect;
        data["mark"] = this.mark;
        data["earnedPoints"] = this.earnedPoints;
        return data; 
    }

    clone(): ResponseEntry {
        const json = this.toJSON();
        let result = new ResponseEntry();
        result.init(json);
        return result;
    }
}

export interface IResponseEntry {
    key: string | undefined;
    values: { [key: string]: string; } | undefined;
    hasValue: boolean;
    isCorrect: boolean | undefined;
    mark: MarkResultKind;
    earnedPoints: number;
}

export class ProblemResponseDto implements IProblemResponseDto {
    id: string;
    attemptId: string;
    itemId: string;
    isAnswered: boolean;
    mark: Mark;
    problemType: string | undefined;
    markerMode: MarkerModeKind;
    markStatus: MarkStatusKind;
    entries: { [key: string]: ResponseEntry; } | undefined;
    comments: string | undefined;

    constructor(data?: IProblemResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attemptId = _data["attemptId"];
            this.itemId = _data["itemId"];
            this.isAnswered = _data["isAnswered"];
            this.mark = _data["mark"] ? Mark.fromJS(_data["mark"]) : <any>undefined;
            this.problemType = _data["problemType"];
            this.markerMode = _data["markerMode"];
            this.markStatus = _data["markStatus"];
            if (_data["entries"]) {
                this.entries = {} as any;
                for (let key in _data["entries"]) {
                    if (_data["entries"].hasOwnProperty(key))
                        (<any>this.entries)[key] = _data["entries"][key] ? ResponseEntry.fromJS(_data["entries"][key]) : new ResponseEntry();
                }
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): ProblemResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attemptId"] = this.attemptId;
        data["itemId"] = this.itemId;
        data["isAnswered"] = this.isAnswered;
        data["mark"] = this.mark ? this.mark.toJSON() : <any>undefined;
        data["problemType"] = this.problemType;
        data["markerMode"] = this.markerMode;
        data["markStatus"] = this.markStatus;
        if (this.entries) {
            data["entries"] = {};
            for (let key in this.entries) {
                if (this.entries.hasOwnProperty(key))
                    (<any>data["entries"])[key] = this.entries[key] ? this.entries[key].toJSON() : <any>undefined;
            }
        }
        data["comments"] = this.comments;
        return data; 
    }

    clone(): ProblemResponseDto {
        const json = this.toJSON();
        let result = new ProblemResponseDto();
        result.init(json);
        return result;
    }
}

export interface IProblemResponseDto {
    id: string;
    attemptId: string;
    itemId: string;
    isAnswered: boolean;
    mark: Mark;
    problemType: string | undefined;
    markerMode: MarkerModeKind;
    markStatus: MarkStatusKind;
    entries: { [key: string]: ResponseEntry; } | undefined;
    comments: string | undefined;
}

export class GetQuizAttemptResponse implements IGetQuizAttemptResponse {
    activityId: string;
    attemptId: string;
    attempt: QuizAttemptDto;
    items: QuizActivityItemDto[] | undefined;
    pages: QuizPageDto[] | undefined;
    responses: ProblemResponseDto[] | undefined;

    constructor(data?: IGetQuizAttemptResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.attemptId = _data["attemptId"];
            this.attempt = _data["attempt"] ? QuizAttemptDto.fromJS(_data["attempt"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(QuizActivityItemDto.fromJS(item));
            }
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages.push(QuizPageDto.fromJS(item));
            }
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses.push(ProblemResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQuizAttemptResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuizAttemptResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["attemptId"] = this.attemptId;
        data["attempt"] = this.attempt ? this.attempt.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetQuizAttemptResponse {
        const json = this.toJSON();
        let result = new GetQuizAttemptResponse();
        result.init(json);
        return result;
    }
}

export interface IGetQuizAttemptResponse {
    activityId: string;
    attemptId: string;
    attempt: QuizAttemptDto;
    items: QuizActivityItemDto[] | undefined;
    pages: QuizPageDto[] | undefined;
    responses: ProblemResponseDto[] | undefined;
}

export class ResponseEntryDto implements IResponseEntryDto {
    key: string | undefined;
    values: { [key: string]: string; } | undefined;

    constructor(data?: IResponseEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)[key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): ResponseEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key];
            }
        }
        return data; 
    }

    clone(): ResponseEntryDto {
        const json = this.toJSON();
        let result = new ResponseEntryDto();
        result.init(json);
        return result;
    }
}

export interface IResponseEntryDto {
    key: string | undefined;
    values: { [key: string]: string; } | undefined;
}

export class UpdateProblemResponseDto implements IUpdateProblemResponseDto {
    id: string;
    itemId: string;
    itemNumber: number;
    problemType: string | undefined;
    entries: ResponseEntryDto[] | undefined;
    isAnswered: boolean;

    constructor(data?: IUpdateProblemResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.itemNumber = _data["itemNumber"];
            this.problemType = _data["problemType"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries.push(ResponseEntryDto.fromJS(item));
            }
            this.isAnswered = _data["isAnswered"];
        }
    }

    static fromJS(data: any): UpdateProblemResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProblemResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["itemNumber"] = this.itemNumber;
        data["problemType"] = this.problemType;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        data["isAnswered"] = this.isAnswered;
        return data; 
    }

    clone(): UpdateProblemResponseDto {
        const json = this.toJSON();
        let result = new UpdateProblemResponseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProblemResponseDto {
    id: string;
    itemId: string;
    itemNumber: number;
    problemType: string | undefined;
    entries: ResponseEntryDto[] | undefined;
    isAnswered: boolean;
}

export class SaveAnswersRequest implements ISaveAnswersRequest {
    quizId: string;
    attemptId: string;
    responses: UpdateProblemResponseDto[] | undefined;

    constructor(data?: ISaveAnswersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quizId = _data["quizId"];
            this.attemptId = _data["attemptId"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses.push(UpdateProblemResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveAnswersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAnswersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quizId"] = this.quizId;
        data["attemptId"] = this.attemptId;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SaveAnswersRequest {
        const json = this.toJSON();
        let result = new SaveAnswersRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveAnswersRequest {
    quizId: string;
    attemptId: string;
    responses: UpdateProblemResponseDto[] | undefined;
}

export class SaveAnswersResponse implements ISaveAnswersResponse {
    problemIds: string[] | undefined;

    constructor(data?: ISaveAnswersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["problemIds"])) {
                this.problemIds = [] as any;
                for (let item of _data["problemIds"])
                    this.problemIds.push(item);
            }
        }
    }

    static fromJS(data: any): SaveAnswersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAnswersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.problemIds)) {
            data["problemIds"] = [];
            for (let item of this.problemIds)
                data["problemIds"].push(item);
        }
        return data; 
    }

    clone(): SaveAnswersResponse {
        const json = this.toJSON();
        let result = new SaveAnswersResponse();
        result.init(json);
        return result;
    }
}

export interface ISaveAnswersResponse {
    problemIds: string[] | undefined;
}

export class SubmitQuizRequest implements ISubmitQuizRequest {
    attemptId: string;
    quizId: string;
    responses: UpdateProblemResponseDto[] | undefined;

    constructor(data?: ISubmitQuizRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
            this.quizId = _data["quizId"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses.push(UpdateProblemResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmitQuizRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitQuizRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        data["quizId"] = this.quizId;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SubmitQuizRequest {
        const json = this.toJSON();
        let result = new SubmitQuizRequest();
        result.init(json);
        return result;
    }
}

export interface ISubmitQuizRequest {
    attemptId: string;
    quizId: string;
    responses: UpdateProblemResponseDto[] | undefined;
}

export class QuizResultDto implements IQuizResultDto {
    totalProblems: number;
    correctProblems: number;
    incorrectProblems: number;
    partiallyCorrectProblems: number;
    notAttempedProblems: number;
    score: ScoreResult;
    feedback: FeedbackResult;
    points: number;

    constructor(data?: IQuizResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProblems = _data["totalProblems"];
            this.correctProblems = _data["correctProblems"];
            this.incorrectProblems = _data["incorrectProblems"];
            this.partiallyCorrectProblems = _data["partiallyCorrectProblems"];
            this.notAttempedProblems = _data["notAttempedProblems"];
            this.score = _data["score"] ? ScoreResult.fromJS(_data["score"]) : <any>undefined;
            this.feedback = _data["feedback"] ? FeedbackResult.fromJS(_data["feedback"]) : <any>undefined;
            this.points = _data["points"];
        }
    }

    static fromJS(data: any): QuizResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProblems"] = this.totalProblems;
        data["correctProblems"] = this.correctProblems;
        data["incorrectProblems"] = this.incorrectProblems;
        data["partiallyCorrectProblems"] = this.partiallyCorrectProblems;
        data["notAttempedProblems"] = this.notAttempedProblems;
        data["score"] = this.score ? this.score.toJSON() : <any>undefined;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["points"] = this.points;
        return data; 
    }

    clone(): QuizResultDto {
        const json = this.toJSON();
        let result = new QuizResultDto();
        result.init(json);
        return result;
    }
}

export interface IQuizResultDto {
    totalProblems: number;
    correctProblems: number;
    incorrectProblems: number;
    partiallyCorrectProblems: number;
    notAttempedProblems: number;
    score: ScoreResult;
    feedback: FeedbackResult;
    points: number;
}

export class SubmitQuizResponse implements ISubmitQuizResponse {
    markStatus: MarkStatusKind;
    isCompleted: boolean;
    result: QuizResultDto;
    results: ProblemResponseDto[] | undefined;

    constructor(data?: ISubmitQuizResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markStatus = _data["markStatus"];
            this.isCompleted = _data["isCompleted"];
            this.result = _data["result"] ? QuizResultDto.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results.push(ProblemResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmitQuizResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitQuizResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["markStatus"] = this.markStatus;
        data["isCompleted"] = this.isCompleted;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SubmitQuizResponse {
        const json = this.toJSON();
        let result = new SubmitQuizResponse();
        result.init(json);
        return result;
    }
}

export interface ISubmitQuizResponse {
    markStatus: MarkStatusKind;
    isCompleted: boolean;
    result: QuizResultDto;
    results: ProblemResponseDto[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}